import { useResource } from "../../../Hooks/UseResource";

function BankVerificationResource() {
  const [resourceError, loading, getData, postData] = useResource();

  const performNonFinancialTransaction = (bankVerificationInputDTO) => {
    return postData({
      url: "public/bank-verification-non-financial",
      data: bankVerificationInputDTO,
    });
  };

  const performFinancialTransaction = (bankVerificationInputDTO) => {
    return postData({
      url: "public/perform-bank-verification",
      data: bankVerificationInputDTO,
    });
  };

  const validateBankVerification = () => {
    return postData({
      url: "public/validate-bank-verification" 
    });
  };

  return [performNonFinancialTransaction, performFinancialTransaction, validateBankVerification];
}

export default BankVerificationResource;
